import { prefixHolder } from './prefix-holder';

export const APIPaths = {
    Backend: prefixHolder.Backend,
    Gateway: prefixHolder.Gateway,
    WebFrontend: prefixHolder.WebFrontend,
    QueryPath: `${prefixHolder.Backend}/query`,
    SubscriptionsPath: `${prefixHolder.WebSocket}/query`,
    SignalRPath: `${prefixHolder.Backend}/messages`,
};
